import styled from "styled-components";

export const ContainerTooltip = styled.div`
  width: 100%;
  min-height: 64.67px;
  background-color: ${(props) => props.theme.colors.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #555f66;
  border-radius: 4px;

  svg {
    width: 16.67px;
    height: 16.67px;
    fill: ${(props) => props.theme.colors.text.default};
  }

  svg path {
    fill: ${(props) => props.theme.colors.text.default};
  }
`;

export const TooltipTitle =  styled.h2`
  margin: 0 0 0 13px;
  height: 16px;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: #f5f6fa;
`